"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
export default function ClientOnly(t0) {
  const $ = _c(6);
  const {
    children,
    fallback: t1
  } = t0;
  const fallback = t1 === undefined ? null : t1;
  const [hasMounted, setHasMounted] = useState(false);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setHasMounted(true);
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  if (!hasMounted) {
    let t4;
    if ($[2] !== fallback) {
      t4 = <>{fallback}</>;
      $[2] = fallback;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    return t4;
  }
  let t4;
  if ($[4] !== children) {
    t4 = <>{children}</>;
    $[4] = children;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}